<template>
  <div class="product-downloads" :data-id="product.id">
    <div class="file-container" v-if="files && files.length > 0">
      <download-file v-for="file in files" :key="file.id" :file="file"></download-file>
    </div>
    <div class="no-files" v-if="!files || files.length === 0" v-html="labels.noOtherFiles"></div>
  </div>
</template>

<script>
import Labels from "../services/labels.js";
import Utils from "../services/utils.js";
import DataLayer from "../services/datalayer.js";
import DownloadFile from "./DownloadFile.vue";

export default {
  name: 'ProductDownloads',
  components: {
    DownloadFile
  },
  props: [
    "product"
  ],
  data () {
    return {
      labels: Labels,
      files: null,
    }
  },
  mounted () {
    this.loadFiles();
  },
  methods : {
    loadFiles() {
      if (!this.$props.product || !this.$props.product.id) return;
      let self = this;
      self.files = null;
      let loader = Utils.showLoader(`.product-downloads[data-id='${this.$props.product.id}']`);
      DataLayer.getProductFiles(this.$props.product.id)
        .then(res => {
          self.files = res.data;
          Utils.removeLoader(loader);
        })
        .catch(err => {
          Utils.removeLoader(loader);
          Utils.showStatusMessage(`${Labels.errorDuringSearch}. ${err}`);
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.file-container {
  position: relative;
}
</style>